import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AmountButtons from "./AmountButtons";
import { FaTrash } from "react-icons/fa";
import {
  cartTotalsSuccess,
  removeCartSuccess,
  toggleAmountSuccess,
} from "../../reducers/users/user";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CartItem = (props) => {
  const {
    param,
    amount,
    categoryId,
    categoryName,
    name,
    price,
    productId,
    productImage,
    productWeight,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state.cart);
  const addProductLimit = () => {
    const data = cart.filter((item) => item?.productId === productId);
    if (data[0]?.stock >= amount) {
      return true;
    } else {
      return false;
    }
  };
  const increaseCart = () => {
    if (addProductLimit()) {
      dispatch(
        toggleAmountSuccess({
          id: productId,
          value: "inc",
        })
      );
    }
  };
  const decreaseCart = () => {
    if (amount > 1) {
      dispatch(
        toggleAmountSuccess({
          id: productId,
          value: "dec",
        })
      );
    } else {
      dispatch(removeCartSuccess(productId));
    }
  };

  const { isDisabled } = useSelector((state) => state.common);
  useEffect(() => {
    dispatch(cartTotalsSuccess());
  }, [cart]);
  return (
    <>
      {/* <div className="cart-list-main"> */}

      <tr>
        <td onClick={() => navigate(`/product/${productId}`)}>
          <div className="title-card cursor-pointer  ">
            <img src={productImage[0]} alt={name} />{" "}
            {/* need to change image */}
            <div>
              <h5 className="name ad-text-primary">{name}</h5>
              {/* <p className="color">
              color:
              <span style={{ background: "red" }}></span>
            </p> */}
              <h5 className="price-small">${price}</h5>
            </div>
          </div>
        </td>
        <td className="align-middle">
          <div>
            <h5 className="price-none ad-text-primary">
              ${price?.toString().includes(".") ? Number(price)?.toFixed(2) : price}
            </h5>
          </div>
        </td>
        <td className="align-middle">
          <div>
            <AmountButtons
              className="fs-5   ad-text-primary "
              amount={amount}
              param={param}
              increase={increaseCart}
              decrease={decreaseCart}
            />
          </div>
        </td>
        <td className="align-middle">
          <div>
            <h5 className="subtotal ad-text-primary">
              $
              {(price * amount).toString().includes(".")
                ? (price * amount)?.toFixed(2)
                : price * amount}
            </h5>
          </div>
        </td>
        {!isDisabled && (
          <td className="align-middle">
            <div>
              <button
                type="button"
                className="remove-btn"
                onClick={() => {
                  dispatch(removeCartSuccess(productId));
                }}
              >
                <FaTrash />
              </button>
            </div>
          </td>
        )}
      </tr>

      {/* </div> */}
    </>
  );
};

export default CartItem;
